import Gateway from './gateway';
import { GatewayResponse, ProtectedRoute } from '~types/gateway';

import {
    TAPIKeyHistoryListingApiParams,
    TAPIKeyHistoryListingResponse,
    TAPIKeySettingsReduxResponse,
    TCreateAdminSettingsAPIParams,
    TGetPendingProductListingReduxResponse,
    TGetPendingProjectListingReduxResponse,
    TGetProductChangeHistoryAPIParams,
    TGetProjectChangeHistoryAPIParams,
    TGetSettingsAPIParams,
    TGetSettingsAPIResponse,
    TUpdateGlobalAndProductSettingsAPIParams,
} from '~types/feat/setting';

export abstract class ISettingGateway extends Gateway {
    abstract getSettings(params: TGetSettingsAPIParams): GatewayResponse<TGetSettingsAPIResponse>;

    abstract updateSettings(params: TUpdateGlobalAndProductSettingsAPIParams): GatewayResponse<null>;

    abstract getProductChangeHistoryListing(params: TGetProductChangeHistoryAPIParams): GatewayResponse<TGetPendingProductListingReduxResponse>;

    abstract getApiKeySettings(params: ProtectedRoute): GatewayResponse<TAPIKeySettingsReduxResponse>;

    abstract updateApiKeySettings(params: ProtectedRoute): GatewayResponse<TAPIKeySettingsReduxResponse>;

    abstract getSilverApiKeySettings(params: ProtectedRoute): GatewayResponse<TAPIKeySettingsReduxResponse>;

    abstract updateSilverApiKeySettings(params: ProtectedRoute): GatewayResponse<TAPIKeySettingsReduxResponse>;

    abstract getSilverApiKeyHistoryListing(params: TAPIKeyHistoryListingApiParams): GatewayResponse<TAPIKeyHistoryListingResponse>;

    abstract getProjectChangeHistoryListing(params: TGetProjectChangeHistoryAPIParams): GatewayResponse<TGetPendingProjectListingReduxResponse>;

    abstract createAdminSettings(params: TCreateAdminSettingsAPIParams): GatewayResponse<null>;
}
